import { GET_USER_TEAMS } from 'actions/Types';

export default (state = null, action) => {
  if (action.type === `${GET_USER_TEAMS}_SUCCESS`) {
    return action.payload.map(t => t.team);
  }

  return state;
};
